/** Authentication Service */

import { authAPI } from './api';
import { getStorageValue, setStorageValue, clearAllStorage } from '../utils/helpers';
import { ROLE_CONFIG, STORAGE_KEYS } from '../config/constants';

const getRoleStoragePrefix = (role) => {
  const prefixMap = {
    super_admin: 'superadmin',
    manager: 'manager',
    supervisor: 'supervisor',
    helpdesk_agent: 'helpdesk'
  };
  return prefixMap[role] || 'helpdesk';
};

export const authService = {
  /**
   * Login user
   */
  login: async (username, password) => {
    const data = await authAPI.login(username, password);

    if (data.token && data.user) {
      const prefix = getRoleStoragePrefix(data.user.role);
      localStorage.setItem(`${prefix}${STORAGE_KEYS.TOKEN}`, data.token);
      localStorage.setItem(`${prefix}${STORAGE_KEYS.USER}`, JSON.stringify(data.user));
      localStorage.setItem('role', data.user.role);
    }

    return data;
  },

  /**
   * Logout user
   */
  logout: async () => {
    try {
      await authAPI.logout();
    } catch (err) {
      console.error('Logout error:', err);
    }
    clearAllStorage();
  },

  /**
   * Get current user from storage
   */
  getCurrentUser: () => {
    const role = localStorage.getItem('role') || 'helpdesk_agent';
    const prefix = getRoleStoragePrefix(role);
    return getStorageValue(`${prefix}${STORAGE_KEYS.USER}`, null);
  },

  /**
   * Get auth token
   */
  getToken: () => {
    const role = localStorage.getItem('role') || 'helpdesk_agent';
    const prefix = getRoleStoragePrefix(role);
    return localStorage.getItem(`${prefix}${STORAGE_KEYS.TOKEN}`);
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: () => {
    return !!authService.getToken() && !!authService.getCurrentUser();
  },

  /**
   * Get user role
   */
  getUserRole: () => {
    return localStorage.getItem('role') || 'helpdesk_agent';
  },

  /**
   * Check if user has role
   */
  hasRole: (role) => {
    return authService.getUserRole() === role;
  },

  /**
   * Check if user has permission (role-based)
   */
  hasPermission: (permission) => {
    const role = authService.getUserRole();
    const config = ROLE_CONFIG[role];
    return config && config[permission] === true;
  },

  /**
   * Get role configuration
   */
  getRoleConfig: () => {
    const role = authService.getUserRole();
    return ROLE_CONFIG[role] || ROLE_CONFIG.super_admin;
  }
};

export default authService;
